import { observer } from 'mobx-react';
import * as React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { Theme } from '../Theme/Theme';
import { useTrans } from '../Store/System/LocalizationStore';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;


const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${Theme.Colors.white};
  animation: ${fadeIn} 0.3s ease-out;
`;

const LogoContainer = styled.div`
  position: relative;
  margin-bottom: 24px;
`;

const SpinnerRing = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid ${Theme.Colors.lightestGrey};
  border-top-color: ${Theme.Colors.primary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${Theme.Colors.warmGrey};
`;

export type LoadingContainerProps = {
  text?: string;
};

export const LoadingContainer: React.FC<LoadingContainerProps> = observer(({ text }) => {
  const { t } = useTrans();

  return (
    <Container>
      <LogoContainer>
        <SpinnerRing />
      </LogoContainer>
      <LoadingText>{text || t('common.loading')}</LoadingText>
    </Container>
  );
});
